import * as yup from 'yup';

const errorMessage = 'Vinsamlegast skiljið reitinn ekki eftir auðann';
// const fileErrorMessage = 'Vinsamlegast skiljið ekki viðhengi eftir autt';

export const TravelExpensesFormValidation = yup.object().shape({
  costType: yup.string().required(errorMessage),
  country: yup.string().nullable(),
  city: yup.string().nullable(),
  amount: yup.string().required(errorMessage),
  paymentMethod: yup.string().required(errorMessage),
  attachments: yup.array(),
});
